import React, {
  useState,
  useEffect,
  useMemo,
  Suspense,
  lazy,
  useCallback,
} from "react";
import "../../css/backlink.scss";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CardOverviewValue from "../../share/card-layout/card-overview-value";
import axios from "axios";
import { CSVLink } from "react-csv";
import { curday, formatDate } from "../../share/upDater/constant";
import { DottLoader } from "../../share/loader";
import { useSelector, useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { motion, AnimatePresence } from "framer-motion";
import { FiDownload } from "react-icons/fi";
import {
  get_backlink_data,
  get_domainauthority,
  post_backlink_data,
  get_user_backlinklimit,
  post_user_backlinklimit,
  update_user_backlinklimit,
  post_morebacklink,
  get_backlinktotallmtGet,
  post_backlinktotallmt,
  update_backlinktotallmtupdate,
  GET_ALLLIST_BACKLINKS,
  POST_NEWLIST_BACKLINKS,
  DELETE_LIST_BACKLINKS,
  PUT_ADDBACKLINKS,
  USER_BACKLINK_LIST_URLEML,
  USER_BACKLINK_LIST_URL,
} from "../../../services/constants";
import { ScrollToView } from "../../share/helper-js/scroll-into-view";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { getCurrentYear } from "../../share/helper-js/current-year";
import { Delete } from "@mui/icons-material";
import AlertPopUp from "../../share/components/alert.component";
import { backlinks, ViewAllListBackLink } from "../../../Navigation/constant";
import PopOver from "../../share/components/popover.component";
import addIcon from "../../Assets/rank-tracking-assets/add.svg";
import exportIcon from "../../Assets/rank-tracking-assets/export-file.svg";
import searchIcon from "../../Assets/rank-tracking-assets/search.svg";
import backlinkIcon from "../../Assets/backlink/backlink.svg";
import refferingDomainIcon from "../../Assets/backlink/reffering-domain.svg";
import domainRankIcon from "../../Assets/backlink/domain-rank.svg";
import LineAlert from "../../share/components/lineAlert";
import ListBulletM from "@semcore/ui/icon/ListBullet/m";

import {
  domainRegex,
  formatNumberWithSymbols,
  handleInvitedUserAccess,
} from "../../../helperJs/helper";
import Tooltip from "../../share/components/tooltip";
import { dynamicSort } from "../../../helperJs/helper";
import { ZustandStore } from "../../../store/zustand-store";
import html2canvas from "html2canvas";
import BackLinksPdfModal from "../Modals/PdfModals/BackLinksPdfModal";
import { handleSaveHistory } from "../Search-History/searchOperations";
import LastCheck from "../Search-History/LastCheck";
import HistoryIcon from "@mui/icons-material/History";
import LoadingButton from "../../share/components/LoadingButton";
import RefreshDataButton from "../../share/components/RefreshDataButton";
import { framerSidebarBackground } from "../../share/components/framer/helper";
import BacklinkRefDomain from "./backlink-Ref-Domain";
import FallbackLoader from "../../share/components/FallbackLoader";
import BacklinkTable from "../../share/tables/backlink/backlinkTable";
import PdfModalDialog from "../../share/pdf/PdfModalDialog";
import TableSettings from "../../share/tables/DynamicTable/table-settings";
import { GET_LINKFEATURE_API } from "../../../Adsy/services/api";
import { useTranslation } from "react-i18next";
import ChartWrapper from "../../share/d3-charts/ChartWrapper";
import { chartType } from "../../share/d3-charts/helper";
import NegativeStackedBarChart from "../../share/d3-charts/NegativeStackedBarChart";
import LineChart from "../../share/d3-charts/LineChart";

import Input from "@semcore/ui/input";
import ArrowRightM from "@semcore/ui/icon/ArrowRight/m";
import RecentM from "@semcore/ui/icon/Recent/m";
import DropdownMenu from "../../../common/components/dropdown";
import SemButton from "../../../common/components/Button";
import BacklinkGuestPost from "./backlink-guest-post";
import { useTableBlur } from "../../share/custom-hook/useTableBlur";

const BacklinkTableFilters = lazy(() =>
  import("../../share/components/table-filter/BacklinkTableFilters")
);
const AnchorTable = lazy(() =>
  import("../../share/tables/backlink/anchorTable")
);

const BackLinks = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(false);
  const [CreateList, setCreateList] = useState(false);
  const [ViewAllLists, setViewAllLists] = useState([]);
  const [pdfLoader, setPdfLoader] = useState(false);
  const [ListValue, setListValue] = useState("");
  const [alertMsg, setalertMsg] = useState(false);
  const [ListChooseErr, setListChooseErr] = useState(false);
  const [inputEmptyErr, setinputEmptyErr] = useState(false);
  const [DeleteLoading, setDeleteLoading] = useState(false);
  const [ListName, setListName] = useState("");
  const [limitTableData, setLimitTableData] = useState([]);
  const [limitShow, setLimitShow] = useState(1);
  const [Keyword, setKeyword] = useState("");
  const [Domain, setDomain] = useState("Domain");
  const [loader, setLoader] = useState(false);
  const [ExcludeSubdomains, setExcludeSubdomains] = useState(false);
  const backlinkDomain = useSelector((state) => state.backlinkDomain);
  const backlinklimits = useSelector((state) => state.backlinkLimit);
  const userRowLmt = backlinklimits?.backlinks_rows_limit;
  const EMAIL = useSelector((state) => state.email);

  const {
    backlink_analysis,
    get_domain_authority,
    userAccessData,
    backlinkTableColumn,
    updateBacklinkTableColumn,
  } = ZustandStore((state) => state);

  const page_data = userAccessData?.[0]?.access;
  const isPageAccess = handleInvitedUserAccess("backlinks", page_data);
  const data_len = 200;
  const queryParams = new URLSearchParams(location.search);
  const email = localStorage.getItem("admin_mail");
  const totalShowTable = data_len * limitShow;

  function handleClose() {
    setAnchorEl(false);
    setListValue("");
    setalertMsg(false);
    setinputEmptyErr(false);
    setTimeout(() => {
      setCreateList(false);
    }, 500);
    setListName("");
  }

  const HandleOpenAddList = () => {
    setCreateList(true);
  };

  const HandleOpen = () => {
    setAnchorEl(true);
  };

  const getLinkFeature = async () => {
    try {
      const resp = await axios.get(GET_LINKFEATURE_API());
      ZustandStore.setState({
        get_link_feature: resp.data.slice(0, 100),
      });
    } catch (error) {
      ZustandStore.setState({
        get_link_feature: [],
      });
    }
  };

  useEffect(() => {
    getLinkFeature();
  }, []);

  const handleBacklinkDataUpdate = (data, type) => {
    setError("");
    if (data?.data?.length === 0) {
      ZustandStore.setState({
        backlink_analysis: { data: [], type: "" },
      });
      setData([]);
      setTableData([]);
      setLimitTableData([]);
      setError(`Sorry, No Data for this domain. Please check the domain`);
      setLoader(false);
      return;
    }
    setData(data);
    const backlink_data = type === "get" ? data?.data?.[0]?.data : data?.data;
    const token =
      type === "get"
        ? data.data?.[0]?.search_after_token
        : data?.search_after_token;
    sessionStorage.setItem("search_after_token", token || "");
    setLimitTableData(backlink_data);
    setTableData(backlink_data?.slice(0, data_len));
    dispatch({ type: "BACKLINKDOMAIN", payload: null });
    setLoader(false);
  };

  const handleDomainAuthorityData = (config) => {
    axios
      .get(get_domainauthority(config.domain))
      .then((response) => {
        ZustandStore.setState({
          get_domain_authority: response?.data,
        });
      })
      .catch(() => {
        ZustandStore.setState({
          get_domain_authority: 0,
        });
      });
  };

  const handleUserBacklinkHistoryData = (config) => {
    axios.get(get_backlink_data(config)).then((response) => {
      if (response.data?.length > 0) {
        const data = response.data?.[response?.data?.length - 1];
        ZustandStore.setState({
          backlink_analysis: { data, type: "get" },
        });
        handleDomainAuthorityData(config);
        handleBacklinkDataUpdate(data, "get");
      } else {
        setKeyword("");
        setLoader(false);
        sessionStorage.removeItem("lastbacklinkdomain");
        removeQueryParamToURL();
      }
    });
  };

  const backlinkGetData = async (api) => {
    return await axios.get(api).then((response) => {
      return response;
    });
  };

  const handleUserBacklinkLimitOnRefresh = (config) => {
    setLimitAlert("");
    setData([]);
    setTableData([]);
    setLimitTableData([]);
    handleUserBacklinkHistoryData(config);
  };

  function isDomain(str) {
    if (str === "") return;
    const domainPattern = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/i;
    return domainPattern.test(str) ? "Domain" : "Exact URL";
  }

  useEffect(() => {
    const domainName = sessionStorage.getItem("lastbacklinkdomain");
    const email = localStorage.getItem("admin_mail");
    const tabOption = sessionStorage.getItem("backlinkTab");
    if (tabOption != null) {
      setSelectedTab(Number(tabOption) || 1);
    }
    if (!isPageAccess) {
      sessionStorage.removeItem("lastbacklinkdomain");
      setKeyword("");
    } else if (backlinkDomain != null) {
      setKeyword(backlinkDomain);
      setLoader(true);
      sessionStorage.setItem("lastbacklinkdomain", backlinkDomain);
      const config = {
        email: email,
        domain: backlinkDomain,
        include_subdomains: !ExcludeSubdomains,
      };

      backlinklimits?.backlinks_domain_lmt &&
        handleUserBacklinkData(config, "get");
    } else if (domainName != null) {
      setKeyword(domainName);
      setLoader(true);
      const config = {
        email: email,
        domain: domainName,
        include_subdomains: !ExcludeSubdomains,
      };
      addQueryParamToURL(domainName);
      if (
        get_domain_authority?.length === 0 &&
        backlink_analysis?.data?.length === 0
      ) {
        backlinklimits?.backlinks_domain_lmt &&
          handleUserBacklinkLimitOnRefresh(config);
      } else {
        handleBacklinkDataUpdate(
          backlink_analysis.data,
          backlink_analysis.type
        );
        setLoader(false);
      }
    }
  }, [isPageAccess, backlinklimits, backlinkDomain]);

  const [Error, setError] = useState();
  const [Data, setData] = useState([]);

  // anchor list
  const [anchorList, setAnchorList] = useState(false);

  // table state
  const [tableData, setTableData] = useState([]);
  const [tableMoreData, setTableMoreData] = useState([]);
  const [tablePage, setTablePage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableMessage, setTableMessage] = useState("");
  const [tableLoader, setTableLoader] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [limitAlert, setLimitAlert] = useState("");
  const [sortDirection, setSortDirection] = useState(true);
  const [FilterData, setFilterData] = useState({
    isFilter: false,
    data: [],
  });

  const maxAllowedPage = 1; // for trial users
  const shouldTableBlur = useTableBlur({
    currentPage: tablePage,
    blurFromPage: maxAllowedPage,
  });
  const backlinkData = useMemo(() => {
    if (FilterData.isFilter) {
      return FilterData.data;
    } else {
      return tableData || [];
    }
  }, [FilterData, tableData, t]);

  const headers = [
    {
      label: "Page Title",
      key: "page_title",
    },
    {
      label: "Source Url",
      key: "Source",
    },
    {
      label: "Target Url",
      key: "Target",
    },
    { label: "Domain Authority", key: "domain_authority" },
    { label: "Page Authority", key: "Page_authority" },
    { label: "Spam Score", key: "spam_score" },
    { label: "Anchor Text", key: "anchor_text" },
    { label: "First Seen", key: "first_seen" },
    { label: "Last Seen", key: "last_seen" },
  ];

  const removeQueryParamToURL = () => {
    const parametersToRemove = ["domain", "exclude-subdomain", "type"];
    const searchParams = new URLSearchParams(location.search);
    parametersToRemove.forEach((param) => {
      searchParams.delete(param);
    });

    const newSearch = searchParams.toString();
    const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;
    navigate(newUrl);
  };

  const addQueryParamToURL = (name) => {
    if (Keyword || name) {
      queryParams.set("domain", Keyword || name);
      queryParams.set("exclude-subdomain", !ExcludeSubdomains);
      queryParams.set("type", Domain || "Domain");
    } else {
      queryParams.delete("domainName");
      queryParams.delete("Exclude-subdomain");
      queryParams.delete("Type");
    }
    const newSearch = queryParams.toString();
    navigate({ search: `?${newSearch}` });
  };

  function filterDuplicates(arr) {
    const uniqueNames = {};
    const result = [];
    for (const item of arr) {
      if (item.domain_from && !uniqueNames[item.domain_from]) {
        uniqueNames[item.domain_from] = true;
        result.push(item);
      }
    }
    return result;
  }

  const anchor_list = useMemo(() => {
    if (Data?.length === 0) return [];
    return Data?.anchor_list ? Data?.anchor_list : Data?.data?.[0]?.anchor_list;
  }, [Data]);

  const search_after_token = sessionStorage.getItem("search_after_token");
  const history_list = Data?.history_list
    ? Data?.history_list
    : Data?.data?.[0]?.history_list;
  const total_backlinks = Data?.total_backlinks
    ? Data?.total_backlinks
    : Data?.data?.[0]?.total_backlinks;

  const postBacklinkLimit = (data) => {
    const domainName = sessionStorage.getItem("lastbacklinkdomain");
    let post_config = {
      email: email,
      domain_name: Keyword || domainName,
      bakclinklmt: data?.length,
    };
    const rowLmt = backlinklimits?.backlinks_rows_limit;
    axios.post(post_user_backlinklimit(), post_config);
    axios.get(get_backlinktotallmtGet(email)).then((response) => {
      if (response.data?.length > 0) {
        axios.put(
          update_backlinktotallmtupdate(
            response?.data[response?.data?.length - 1].id
          ),
          {
            email: email,
            backlinktotallmt:
              response?.data[response?.data?.length - 1].backlinktotallmt -
              data?.length,
          }
        );
      } else if (response.data?.length === 0) {
        axios.post(post_backlinktotallmt(), {
          email: email,
          backlinktotallmt: rowLmt - data?.length,
        });
      }
    });
  };

  const handlePostDataFlow = (config) => {
    axios.get(get_backlinktotallmtGet(email)).then((response) => {
      const userLmt =
        response.data[response.data?.length - 1]?.backlinktotallmt;
      if (response.data?.length > 0) {
        if (userLmt <= 0) {
          setLimitAlert(
            "Your limit for Backlinks search have been exceeded. Please Upgrade"
          );
          ZustandStore.setState({
            backlink_analysis: { data: [], type: "" },
          });
          setData([]);
          setTableData([]);
          setLimitTableData([]);
          setLoader(false);
          return;
        }
      }
      axios
        .post(post_backlink_data(config))
        .then((response) => {
          handleDomainAuthorityData(config);
          if (response.data?.length === 0) {
            ZustandStore.setState({
              backlink_analysis: { data: [], type: "" },
            });
            setData([]);
            setTableData([]);
            setLimitTableData([]);
            setError(`Sorry, No Data for this domain. Please check the domain`);
            setLoader(false);
          } else {
            const backlink_data = response.data[0]?.data;
            postBacklinkLimit(backlink_data, response.data);
            handleBacklinkDataUpdate(response.data[0], "post");
            ZustandStore.setState({
              backlink_analysis: { data: response.data[0], type: "post" },
            });
          }
        })
        .catch(() => {
          ZustandStore.setState({
            backlink_analysis: { data: [], type: "" },
          });
          setData([]);
          setTableData([]);
          setLimitTableData([]);
          setError(`Sorry, No Data for this domain. Please check the domain`);
          setLoader(false);
        });
    });
  };

  const handleUserBacklinkData = async (config, type) => {
    addQueryParamToURL(config.domain);
    setDomain(isDomain(config.domain));
    if (type === "post") {
      handlePostDataFlow(config);
      return;
    }
    axios.get(get_backlink_data(config)).then((response) => {
      handleDomainAuthorityData(config);
      if (response.data?.length > 0) {
        const data = response.data?.[response?.data?.length - 1];
        ZustandStore.setState({
          backlink_analysis: { data, type: "get" },
        });
        handleBacklinkDataUpdate(data, "get");
      } else {
        handlePostDataFlow(config);
      }
    });
  };

  const keywordClickHandler = (e, type) => {
    if (!isPageAccess) return;
    e.preventDefault();
    if (Keyword === "") {
      setError(t("competitive_research.alert_msg.enter_domain"));
    } else if (!domainRegex.test(Keyword) && Domain === "Domain") {
      setError(t("competitive_research.alert_msg.valid_domain"));
      setData([]);
      setTableData([]);
      setLimitTableData([]);
    } else {
      ZustandStore.setState({
        backlink_analysis: { data: [], type: "" },
        get_domain_authority: 0,
        referring_domain: [],
        history_data: {
          data: [],
          error: false,
          loading: true,
        },
      });
      setData([]);
      setTableData([]);
      setLimitTableData([]);
      setLoader(true);
      sessionStorage.setItem("lastbacklinkdomain", Keyword);
      const config = {
        email: email,
        domain: Keyword,
        include_subdomains: !ExcludeSubdomains,
      };
      setLimitAlert("");
      const config2 = {
        domain: Keyword,
        type: "backlinks",
      };
      handleSaveHistory(config2);
      handleUserBacklinkData(config, type);
    }
  };

  const keywordChangeHandler = (value) => {
    setError("");
    if (Domain == "Exact URL") {
      setKeyword(value);
    } else {
      const url = value;
      const match = url.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i);
      setKeyword(match ? match[1].replace(/\s/g, "") : "");
    }
    sessionStorage.removeItem("lastbacklinkdomain");
  };

  const DomainArr = useMemo(() => {
    return {
      value: Domain || t("backlinks.backlink_analysis.form.domain"),
      placeholder: "Select Domain Type",
      disabled: false,
      data: ["Domain", "Exact URL"],
      height: "35px",
      loading: false,
    };
  }, [Domain, t]);

  const domainHandler = useCallback(
    (category) => {
      if (category == "Exact URL") {
        setKeyword(Keyword);
      } else {
        const match = Keyword.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i);
        setKeyword(match ? match[1].replace(/\s/g, "") : "");
      }
      setDomain(category);
    },
    [Keyword]
  );

  const cardValue = [
    {
      id: 1,
      title: t("backlinks.backlink_analysis.overview.box.domain_rank.title"),
      toolkit: t(
        "backlinks.backlink_analysis.overview.box.domain_rank.tooltip"
      ),
      rank: get_domain_authority || 0,
      Src: domainRankIcon,
      color: "backlink-card-background-3",
      bg: "#6A3BE4",
      tab: 2,
    },
    {
      id: 2,
      title: t("backlinks.backlink_analysis.overview.box.ref_domain.title"),
      toolkit: t("backlinks.backlink_analysis.overview.box.ref_domain.tooltip"),
      rank: history_list?.[history_list?.length - 1]?.referring_domains || 0,
      Src: refferingDomainIcon,
      color: "backlink-card-background-4",
      bg: "#6A3BE4",
      tab: 3,
    },
    {
      id: 3,
      title: t("backlinks.backlink_analysis.overview.box.backlinks.title"),
      toolkit: t("backlinks.backlink_analysis.overview.box.backlinks.tooltip"),
      rank: total_backlinks || 0,
      Src: backlinkIcon,
      color: "backlink-card-background-3",
      bg: "#6A3BE4",
      tab: 2,
    },
  ];

  const chart1_data = useMemo(() => {
    if (history_list?.length > 0) {
      const labels = history_list?.map((item) => item.month);
      const positionData = {
        new: history_list?.map((item) => item.new_refeering_domains),
        lost: history_list?.map((item) => {
          const num = item.lost_referring_domains;
          return num > 0 ? -num : num;
        }),
      };

      return {
        labels,
        datasets: chartType.chart1.label?.map((label) => ({
          label: t(label.name),
          data: positionData[label.key] || [], // dynamically pick dataset
          borderColor: label.color,
          fill: "Smooth",
          pointRadius: 0,
          pointHoverRadius: 3,
          pointBorderColor: label.color,
          pointBackgroundColor: label.color,
        })),
      };
    } else {
      return [];
    }
  }, [history_list, chartType.chart1, t]);

  const chart3_data = useMemo(() => {
    if (history_list?.length > 0) {
      const labels = history_list?.map((item) => item.month);
      const positionData = {
        backlinks: history_list?.map((item) => item.backlinks),
        referring_domains: history_list?.map((item) => item.referring_domains),
      };

      return {
        labels,
        datasets: chartType.chart3.label?.map((label) => ({
          label: t(label.name),
          data: positionData[label.key] || [], // dynamically pick dataset
          borderColor: label.color,
          fill: "Smooth",
          pointRadius: 0,
          pointHoverRadius: 3,
          pointBorderColor: label.color,
          pointBackgroundColor: label.color,
        })),
      };
    } else {
      return [];
    }
  }, [history_list, chartType.chart3, t]);

  function createArrayOfObjectsWithId(dataArray) {
    const newArray = [];
    for (let i = 0; i < dataArray?.length; i++) {
      const obj = dataArray[i];
      const id = `unique_id-${tablePage + 1}${i}`;
      obj["sid"] = id;
      newArray.push(obj);
    }
    return newArray;
  }

  const tabOptionFiltered = (data) => {
    setTableLoader(true);
    setTableData(data);
    setTimeout(() => {
      setTableLoader(false);
    }, 200);
  };

  const currentPageTableData = useMemo(() => {
    const itemsPerPage = 100;
    const startIndex = tablePage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const array = backlinkData?.slice(startIndex, endIndex);
    const change = createArrayOfObjectsWithId(array);
    return change;
  }, [backlinkData, tablePage, t]);

  const userTrialData = useMemo(() => {
    const array = backlinkData?.slice(0, 100);
    return createArrayOfObjectsWithId(array);
  }, [backlinkData]);

  const loadCSVData = useMemo(() => {
    if (backlinkData?.length === 0) return [];
    const array = shouldTableBlur.isTrialUser
      ? backlinkData?.slice(0, 100)
      : backlinkData;
    return array?.map((res) => {
      return {
        page_title: res?.page_from_title,
        Source: res?.url_from,
        Target: res?.url_to,
        domain_authority: res?.domain_authority,
        Page_authority: res?.page_authority,
        spam_score: `${res?.backlink_spam_score}%`,
        anchor_text: res?.anchor,
        first_seen: formatDate(res?.first_seen),
        last_seen: formatDate(res?.last_seen),
      };
    });
  }, [backlinkData, shouldTableBlur.isTrialUser]);

  // table search handler
  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      const backlink_table_data = Data?.data?.[0].data
        ? Data?.data?.[0].data || []
        : Data?.data || [];
      const backlink_data = backlink_table_data?.slice(0, data_len);
      if (backlink_data?.length > 0) {
        setTablePage(0);
        const combinedArray = [...backlink_data, ...tableMoreData];
        if (searchQuery?.length == 0) {
          tabOptionFiltered(combinedArray);
        } else {
          const filtered_data = combinedArray?.filter((item) => {
            const query = item?.url_from;
            return query?.toLowerCase().includes(searchQuery.toLowerCase())
              ? item
              : null;
          });
          tabOptionFiltered(filtered_data);
        }
      }
    }, 500);

    return () => {
      clearTimeout(debounce);
    };
  }, [searchQuery]);

  const backlinkTotalLmtUpdate = async (
    backlinkLmtGet,
    backlinkTotalLmtGet
  ) => {
    let data_limit_len = 200; // show table data length
    let post_config = {
      email: email,
      domain_name: Keyword,
      bakclinklmt:
        backlinkLmtGet.data?.[backlinkLmtGet.data?.length - 1]?.limit +
        data_limit_len,
    };
    let post_config2 = {
      email: email,
      backlinktotallmt:
        backlinkTotalLmtGet.data?.[backlinkTotalLmtGet?.data?.length - 1]
          ?.backlinktotallmt - data_limit_len,
    };
    if (backlinkLmtGet.data?.[backlinkLmtGet?.data?.length - 1] < userRowLmt) {
      axios.put(
        update_user_backlinklimit(
          backlinkLmtGet.data?.[backlinkLmtGet.data?.length - 1]?.id
        ),
        post_config
      );
    }

    if (
      backlinkTotalLmtGet?.data[backlinkTotalLmtGet?.data?.length - 1]
        ?.backlinktotallmt <= 0
    ) {
      return;
    }
    axios.put(
      update_backlinktotallmtupdate(
        backlinkTotalLmtGet.data?.[backlinkTotalLmtGet?.data?.length - 1]?.id
      ),
      post_config2
    );
  };

  const handleTableLoadMore = useCallback(async () => {
    setLimitAlert("");
    const config = {
      domain: Keyword,
      include_subdomains: !ExcludeSubdomains,
      searchaftertoken: search_after_token,
      email: email,
    };

    const shown_table_row = limitTableData?.length;

    if (limitTableData?.length > totalShowTable) {
      setTableMessage("Loading more data");
      const limit_show_change = totalShowTable + data_len;
      setLimitShow(limit_show_change / data_len);
      const newData = limitTableData?.slice(0, totalShowTable + data_len);
      tabOptionFiltered(newData);
      setTimeout(() => {
        setTableMessage("");
      }, 1000);
      return;
    }

    const backlinkLmtGet = await backlinkGetData(
      get_user_backlinklimit(config)
    );
    const backlinkTotalLmtGet = await backlinkGetData(
      get_backlinktotallmtGet(email)
    );

    if (
      backlinkTotalLmtGet?.data[backlinkTotalLmtGet?.data?.length - 1]
        ?.backlinktotallmt <= 0
    ) {
      setLimitAlert("Your limit for rows have been exceeded. Please Upgrade");
      return;
    } else if (shown_table_row >= total_backlinks) {
      setTableMessage(`No more data`);
      setTimeout(() => {
        setTableMessage("");
      }, 1000);
      return;
    }

    setTableMessage(`Loading more data please wait`);
    axios.post(post_morebacklink(config)).then((response) => {
      if (response.data?.length === 0) {
        setTableMoreData(tableMoreData);
        tabOptionFiltered(tableData);
        setTableMessage("No more data");
        setTimeout(() => {
          setTableMessage("");
        }, 1000);
      } else {
        backlinkTotalLmtUpdate(backlinkLmtGet, backlinkTotalLmtGet);
        const new_data = response.data?.[0];
        const combinedArray = [...tableMoreData, ...new_data?.data];
        setTableMoreData(combinedArray);
        const limit_show_change = totalShowTable + data_len;
        setLimitShow(limit_show_change / data_len);
        const limitCombinedArray = [...new_data?.data, ...limitTableData];
        setLimitTableData(limitCombinedArray);
        const new_limit_data = new_data?.data?.slice(0, data_len);
        const newData = [...tableData, ...new_limit_data];
        tabOptionFiltered(newData);
        sessionStorage.setItem(
          "search_after_token",
          new_data?.search_after_token || ""
        );
        setTableMessage("");
      }
    });
  }, [
    Keyword,
    ExcludeSubdomains,
    search_after_token,
    email,
    limitTableData,
    totalShowTable,
    data_len,
    total_backlinks,
    tableMoreData,
    tableData,
    backlinkGetData,
    get_user_backlinklimit,
    get_backlinktotallmtGet,
    post_morebacklink,
    backlinkTotalLmtUpdate,
    tabOptionFiltered,
  ]);

  const handleTableSelectedData = useCallback(
    (value, id) => {
      const uniqueId = `unique_id-${tablePage + 1}${id}`;
      const index = selectedData.findIndex((item) => item.sid === uniqueId);
      const newObj = { ...value, sid: uniqueId };

      if (index === -1) {
        setSelectedData((prevSelectedData) => [...prevSelectedData, newObj]);
      } else {
        setSelectedData((prevSelectedData) => {
          const updatedValues = prevSelectedData.filter(
            (item) => item.sid !== uniqueId
          );
          return updatedValues;
        });
      }
    },
    [selectedData, tablePage]
  );

  const selectedFilterData = useMemo(() => {
    const array = filterDuplicates(selectedData);
    const arr = array?.map((item) => {
      return item.url_from;
    });
    return arr;
  }, [selectedData, t]);

  const isCheckboxChecked = useCallback(
    (index) => {
      const id = `unique_id-${tablePage + 1}${index}`;
      return selectedData.some((item) => item.sid === id);
    },
    [selectedData, tablePage] // Dependencies
  );

  // List Api
  const [Alert, setAlert] = useState({
    type: "",
    message: "",
    show: false,
  });

  const FetchLISTING = () => {
    axios.get(GET_ALLLIST_BACKLINKS(EMAIL)).then((Result) => {
      if (Result?.data) {
        setViewAllLists(Result?.data);
        setSelectedData([]);
        setSelectAll(false);
      }
    });
  };

  useEffect(() => {
    FetchLISTING();
  }, []);

  const PAYLOAD = {
    email: EMAIL,
    back_list_name: ListValue,
    backlink_list: selectedFilterData,
  };

  const handleUserAddList = () => {
    const config = {
      email: EMAIL,
      url: selectedFilterData,
    };

    axios.post(USER_BACKLINK_LIST_URLEML(), config);
    axios.post(USER_BACKLINK_LIST_URL(), {
      url: selectedFilterData,
    });
  };

  const HandleCreateBackLIST = () => {
    setalertMsg(false);
    if (ListValue) {
      const Output = ViewAllLists.map((result) => {
        return result.back_list_name === ListValue;
      });
      const ReturnData = Output.includes(true);
      if (ReturnData) {
        setalertMsg(true);
        setTimeout(() => {
          setalertMsg(false);
        }, 3000);
      } else {
        handleUserAddList();
        axios.post(POST_NEWLIST_BACKLINKS(), PAYLOAD).then((res) => {
          setAlert({
            type: "success",
            message: "Created Successfully",
            show: true,
          });
          setSelectedData([]);
          setListValue("");
          FetchLISTING();
          setAnchorEl(false);
          setCreateList(false);
          setinputEmptyErr(false);
        });
      }
    } else {
      setinputEmptyErr(true);
    }
  };

  const handleGetListData = (listData) => {
    setListChooseErr(false);
    setListName(listData?.back_list_name);
  };

  const handleAddBackLink = () => {
    let obj = {
      data: [],
    };
    ViewAllLists?.map((all) => {
      if (all.back_list_name === ListName) {
        const BackLink_list = all.backlink_list;
        const namesInArray1 = new Set(BackLink_list.map((item) => item));
        const array = selectedFilterData.filter(
          (item) => !namesInArray1.has(item)
        );
        obj.data.push(array);
      }
    });
    if (ListName) {
      axios.put(PUT_ADDBACKLINKS(EMAIL, ListName, ...obj.data)).then((res) => {
        setAlert({
          type: "success",
          message: "Added Successfully",
          show: true,
        });
        setListName("");
        setSelectedData([]);
        FetchLISTING();
        setAnchorEl(false);
        setCreateList(false);
      });
    } else {
      setListChooseErr(true);
    }
  };

  const HandleDeleteList = (LIST) => {
    setDeleteLoading(true);
    axios.delete(DELETE_LIST_BACKLINKS(EMAIL, LIST)).then((res) => {
      setAlert({
        type: "success",
        message: "Deleted",
        show: true,
      });
      FetchLISTING();
      setTimeout(() => {
        setDeleteLoading(false);
      }, 500);
    });
  };

  const AddColor = (id) => {
    const Elem = document.getElementsByClassName("ListName");
    const Target = document.getElementById(id);
    for (let index = 0; index < Elem.length; index++) {
      Elem[index].classList.remove("SHOWBg");
    }
    document.getElementById(id).classList.add("SHOWBg");
  };
  //  List End

  const handleCheckboxSelectAll = useCallback(() => {
    setSelectedData(selectAll ? [] : currentPageTableData); // One-liner for setting data
    setSelectAll((prevSelectAll) => !prevSelectAll); // Use functional state update
  }, [currentPageTableData, selectAll]);

  const handleTabOption = (value) => {
    sessionStorage.setItem("backlinkTab", value);
    setSelectedTab(value);
  };

  const handleBacklinkSortClick = useCallback(
    (field) => {
      const sortedData = sortDirection
        ? dynamicSort([...backlinkData], field, "asc")
        : dynamicSort([...backlinkData], field, "desc");

      setTableData(sortedData);
      setSortDirection((prev) => !prev);
    },
    [backlinkData, sortDirection] // Dependencies
  );

  const diffStyle = (val) => {
    if (val <= 30) {
      return {
        backgroundColor: "rgb(108 170 106)",
      };
    } else if (30 < val && val <= 60) {
      return {
        backgroundColor: "rgb(255, 142, 59)",
      };
    } else {
      return {
        backgroundColor: "rgb(233, 86, 85)",
      };
    }
  };

  // print backlinks pdf
  const handleRoute = () => {
    setPdfLoader(true);
    const element = document.getElementById("backL");
    if (element) {
      html2canvas(element, {
        logging: false,
        useCORS: true,
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/jpeg");
          sessionStorage.setItem("dashboardImage", imgData);
          sessionStorage.setItem(
            "pdfSessionData",
            JSON.stringify({ Keyword: Keyword, id: 12 })
          );
          navigate("/CrawledPageEditor");
        })
        .catch((error) => {
          setPdfLoader(false);
          console.error("Error capturing the dashboard as an image:", error);
        });
    }
  };

  const isoDateString =
    Data?.last_updated && Data?.month && Data?.year
      ? `${Data.last_updated}-${Data.month}-${Data.year}`
      : new Date();

  const handleAlert = (alert) => {
    setAlert(alert);
  };

  const columnArr = [
    {
      label: t(
        "backlinks.backlink_analysis.backlinks_table.header.source_page.title"
      ),
      dataKey: "target_page",
      width: "250px",
      sort: false,
      align: "left",
      tooltip: t(
        "backlinks.backlink_analysis.backlinks_table.header.source_page.tooltip"
      ),
      show: true,
      ignore: true,
    },
    {
      label: t("backlinks.backlink_analysis.backlinks_table.header.dr.title"),
      dataKey: "domain_authority",
      sort: true,
      align: "center",
      width: "60px",
      tooltip: t(
        "backlinks.backlink_analysis.backlinks_table.header.dr.tooltip"
      ),
      show: true,
      ignore: true,
    },
    {
      label: t("backlinks.backlink_analysis.backlinks_table.header.pr.title"),
      dataKey: "page_authority",
      sort: true,
      align: "center",
      width: "55px",
      tooltip: t(
        "backlinks.backlink_analysis.backlinks_table.header.pr.tooltip"
      ),
      show: !backlinkTableColumn.includes("PR"),
      ignore: false,
    },
    {
      label: t("backlinks.backlink_analysis.backlinks_table.header.ss.title"),
      dataKey: "backlink_spam_score",
      width: "55px",
      sort: true,
      align: "center",
      tooltip: t(
        "backlinks.backlink_analysis.backlinks_table.header.ss.tooltip"
      ),
      show: !backlinkTableColumn.includes("SS"),
      ignore: false,
    },
    {
      label: t(
        "backlinks.backlink_analysis.backlinks_table.header.anchor_text.title"
      ),
      dataKey: "anchor",
      width: "200px",
      sort: false,
      align: "center",
      tooltip: t(
        "backlinks.backlink_analysis.backlinks_table.header.anchor_text.tooltip"
      ),
      show: !backlinkTableColumn.includes("anchor text"),
      ignore: false,
    },
    {
      label: (
        <>
          {t(
            "backlinks.backlink_analysis.backlinks_table.header.first_seen.title"
          )}
          <br />
          {t(
            "backlinks.backlink_analysis.backlinks_table.header.last_seen.title"
          )}
        </>
      ),
      dataKey: "first_seen",
      width: "100px",
      align: "center",
      tooltip: (
        <>
          {t(
            "backlinks.backlink_analysis.backlinks_table.header.first_seen.tooltip"
          )}
          <br />
          {t(
            "backlinks.backlink_analysis.backlinks_table.header.last_seen.tooltip"
          )}
        </>
      ),
      show: !backlinkTableColumn.includes("first seen"),
      ignore: false,
    },
    // {
    //   label: t(
    //     "backlinks.backlink_analysis.backlinks_table.header.buy_guest.title"
    //   ),
    //   dataKey: "action",
    //   width: "200px",
    //   sort: false,
    //   align: "center",
    //   tooltip: "",
    //   show: false,
    //   ignore: false,
    // },
  ];

  const columns = useMemo(() => {
    if (backlinkTableColumn?.length > 0) {
      return columnArr?.filter((column) => {
        return !backlinkTableColumn?.includes(column.label);
      });
    } else {
      return columnArr;
    }
  }, [backlinkTableColumn, t]);

  return (
    <div>
      <AlertPopUp config={Alert} handleClose={setAlert} />
      <div className="w-100 main-pd" id="backlink_page">
        {limitAlert ? <LineAlert data={limitAlert} /> : null}
        {anchorList ? (
          <Suspense fallback={<FallbackLoader />}>
            <AnchorTable
              {...{
                hideFullList: false,
                anchorList: anchor_list,
                setAnchorList,
              }}
            />
          </Suspense>
        ) : (
          <>
            <div className="keyword2 pb-5">
              <div className="w-100">
                <h5 className="">{t("backlinks.backlink_analysis.title")}</h5>
                <p className="keyword-p mb-0">
                  {t("backlinks.backlink_analysis.discription")}
                </p>
                <form
                  onSubmit={(e) => {
                    keywordClickHandler(e, "get");
                  }}
                >
                  <div className="overview-search-contain d-flex justify-content-between">
                    <div className="d-flex align-items-center justify-content-start flex-wrap gap-2">
                      <div className="keyword-input font-regular heading-small">
                        <Input w={"100%"} h={"35px"}>
                          <Input.Value
                            type={"text"}
                            placeholder={t(
                              "backlinks.backlink_analysis.form.enter_domain"
                            )}
                            value={Keyword || ""}
                            onChange={(value) => {
                              keywordChangeHandler(value);
                            }}
                          />
                        </Input>
                      </div>

                      <div className="dropdon_country_lang">
                        <DropdownMenu
                          {...{
                            menuData: DomainArr,
                            handleSelect: domainHandler,
                          }}
                        />
                      </div>

                      <div className="backlink-checkbox my-2">
                        <input
                          type="checkbox"
                          checked={ExcludeSubdomains}
                          onChange={(e) =>
                            setExcludeSubdomains(!ExcludeSubdomains)
                          }
                        />
                        <label
                          style={{ textWrap: "nowrap" }}
                          className="heading-small"
                        >
                          {t(
                            "backlinks.backlink_analysis.form.exclude_subdomain"
                          )}
                        </label>
                      </div>

                      <SemButton
                        name={t("common_buttons.search")}
                        title={t("common_buttons.search")}
                        disabled={!isPageAccess}
                        onClick={(e) => keywordClickHandler(e, "get")}
                        icon={<ArrowRightM />}
                      />

                      <Link
                        to={"/activity?type=backlinks"}
                        className=""
                        style={{
                          display: selectedTab !== 1 ? "none" : "flex",
                        }}
                      >
                        <SemButton
                          name={t("common_buttons.activity")}
                          title={t("common_buttons.activity")}
                          icon={<RecentM />}
                        />
                      </Link>
                      <RefreshDataButton
                        date={isoDateString}
                        disable={Data?.length === 0 || loader}
                        handleRefresh={keywordClickHandler}
                      />
                      {Data?.length !== 0 ? (
                        <div className="d-flex justify-content-center align-item-center g-2">
                          <LoadingButton loading={pdfLoader}>
                            <FiDownload
                              className="down"
                              style={{
                                display: selectedTab !== 1 ? "none" : "flex",
                              }}
                              onClick={handleRoute}
                              title="download BackLinks Overview PDF"
                            />
                          </LoadingButton>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {isPageAccess ? (
                    <>
                      {Data?.length === 0 ? (
                        <LastCheck type="backlinks" />
                      ) : null}
                      {Error ? (
                        <p className="vl-msd-line mt-1 ms-1">
                          <span>{Error}</span>
                        </p>
                      ) : null}
                    </>
                  ) : (
                    <p className="heading-medium font-bold vl-msd-line mt-3 ms-1">
                      <span>{t("backlinks.alert")}</span>
                    </p>
                  )}
                </form>
              </div>
            </div>
            {loader ? (
              <DottLoader />
            ) : Data?.length === 0 ? null : (
              <section className="page-tab-container">
                <nav className="page-tab-nav">
                  <ul>
                    <li
                      className={selectedTab === 1 ? "selected" : ""}
                      onClick={() => handleTabOption(1)}
                    >
                      {t("backlinks.backlink_analysis.pages.overview")}
                    </li>
                    <li
                      className={selectedTab === 2 ? "selected" : ""}
                      onClick={() => handleTabOption(2)}
                    >
                      {t("backlinks.backlink_analysis.pages.backlinks")}
                    </li>
                    <li
                      className={selectedTab === 3 ? "selected" : ""}
                      onClick={() => handleTabOption(3)}
                    >
                      {t("backlinks.backlink_analysis.pages.ref_domain")}
                    </li>
                    <li
                      className={selectedTab === 4 ? "selected" : ""}
                      onClick={() => handleTabOption(4)}
                    >
                      Matching Guest Posts
                    </li>
                  </ul>
                </nav>
                <AnimatePresence mode="wait">
                  <motion.div
                    key={selectedTab ? selectedTab : "empty"}
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -10, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    {selectedTab === 1 ? (
                      <div className="row g-4 mb-4" id="backL">
                        <div className="col-12 col-lg-3 col-xl-2">
                          <div className="row h-100 gy-3">
                            {cardValue?.map((card, index) => {
                              return (
                                <div
                                  className="col-12 col-md-6 col-lg-12 card-overview-value"
                                  key={`backlink-card-${index}`}
                                  onClick={() => handleTabOption(card.tab)}
                                >
                                  <CardOverviewValue
                                    data={card}
                                    id={`backlinkBox${index}`}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className="col-12 col-lg-9 col-xl-7">
                          <ChartWrapper
                            chart={chartType.chart3}
                            key={t(
                              "backlinks.backlink_analysis.overview.backlinks_over_time"
                            )}
                          >
                            <LineChart data={chart3_data} />
                          </ChartWrapper>

                          <div className="mt-4">
                            <ChartWrapper
                              chart={chartType.chart1}
                              key={t(
                                "backlinks.backlink_analysis.overview.chart.new_lost_referring_domains"
                              )}
                            >
                              <NegativeStackedBarChart data={chart1_data} />
                            </ChartWrapper>
                          </div>
                        </div>
                        <div className="col-12 col-lg-12 col-xl-3">
                          <div
                            className="backlink-bar-chart"
                            style={{ overflow: "hidden" }}
                          >
                            <div
                              style={{ overflow: "hidden", height: "545px" }}
                            >
                              <Suspense fallback={<FallbackLoader />}>
                                <AnchorTable
                                  {...{
                                    hideFullList: true,
                                    anchorList: anchor_list,
                                    setAnchorList,
                                  }}
                                />
                              </Suspense>
                            </div>

                            <div className="w-100 cad justify-content-end pe-4 my-2">
                              <SemButton
                                name={t("common_buttons.view_all")}
                                onClick={() => {
                                  ScrollToView("backlink_page");
                                  setAnchorList(true);
                                }}
                                color="#e95655"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : selectedTab === 2 ? (
                      <section className="backlink-data-report">
                        <div className="table-btn-coll">
                          <p className="ttl-bklnk mb-0">
                            {t(
                              "backlinks.backlink_analysis.total_backlink.title"
                            )}
                            <Tooltip
                              title={t(
                                "backlinks.backlink_analysis.total_backlink.tooltip"
                              )}
                            />
                            :{" "}
                            <span>
                              {tableData?.length}
                              {""}/{""}
                              {formatNumberWithSymbols(total_backlinks)}
                            </span>
                          </p>
                          <div className="backlink-search-filed ms-auto">
                            <i className="fa-solid fa-magnifying-glass icon"></i>
                            <input
                              className="input-field heading-small"
                              type="text"
                              placeholder={t(
                                "backlinks.backlink_analysis.buttons.search.placeholder"
                              )}
                              value={searchQuery || ""}
                              onChange={(e) =>
                                handleSearchChange(e.target.value)
                              }
                            />
                          </div>

                          <SemButton
                            disabled={selectedFilterData.length === 0}
                            onClick={HandleOpen}
                            title={t(
                              "backlinks.backlink_analysis.buttons.add_domain.tooltip"
                            )}
                            name={t(
                              "backlinks.backlink_analysis.buttons.add_domain.title"
                            )}
                            icon={<img src={addIcon} alt="" />}
                          />

                          <CSVLink
                            filename={
                              "SEO Tools:" + Keyword + curday() + ".csv"
                            }
                            headers={headers}
                            data={loadCSVData}
                          >
                            <SemButton
                              title={t("common_buttons.export")}
                              disabled={currentPageTableData?.length === 0}
                              icon={<img src={exportIcon} alt="" />}
                              name={t("common_buttons.export")}
                              color="#e95655"
                            />
                          </CSVLink>

                          <Link to={`../${ViewAllListBackLink}`}>
                            <SemButton
                              onClick={HandleOpen}
                              title={t("common_buttons.view_list")}
                              name={t("common_buttons.view_list")}
                              icon={<ListBulletM />}
                              color="#e95655"
                            />
                          </Link>

                          <TableSettings
                            {...{
                              columns: columnArr,
                              updateProjectTableCol: updateBacklinkTableColumn,
                            }}
                          />

                          <FiDownload
                            className="down large-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#staticBackdrop"
                            title="download long description pdf"
                          />
                          <PdfModalDialog>
                            <BackLinksPdfModal
                              currentPageTableData={
                                shouldTableBlur?.isTrialUser
                                  ? userTrialData
                                  : currentPageTableData
                              }
                              diffStyle={diffStyle}
                              domainName={Keyword}
                            />
                          </PdfModalDialog>
                        </div>

                        <Suspense fallback={null}>
                          <BacklinkTableFilters
                            {...{
                              headerArray: columns,
                              tableData,
                              setFilterData,
                            }}
                          />
                        </Suspense>

                        <BacklinkTable
                          {...{
                            selectAll,
                            tableData: backlinkData,
                            handleCheckboxSelectAll,
                            data: currentPageTableData,
                            handleTableSelectedData,
                            isCheckboxChecked,
                            handleBacklinkSortClick,
                            handleTableLoadMore,
                            tableMessage,
                            tableLoader,
                            columns,
                            tablePage,
                            setTablePage,
                          }}
                        />
                      </section>
                    ) : selectedTab === 3 ? (
                      <BacklinkRefDomain
                        domain={Keyword}
                        alertFn={handleAlert}
                      />
                    ) : (
                      <BacklinkGuestPost />
                    )}
                  </motion.div>
                </AnimatePresence>
              </section>
            )}
          </>
        )}
      </div>
      {/* <UnderConstruction /> */}
      <PopOver anchorEl={anchorEl} setAnchorEl={() => setAnchorEl(false)}>
        {CreateList ? (
          <>
            <Box sx={{ width: "100%" }} padding={"1rem"}>
              <Typography
                component="h1"
                id="select-google-property"
                className="heading-large font-bold popover-list-header py-2 px-2"
              >
                Create Backlink List
                <IconButton
                  className="popover-close-icon"
                  onClick={handleClose}
                  sx={{
                    marginRight: "10px",
                    marginTop: "13px",
                    "&:hover": {
                      backgroundColor: "rgba(240, 242, 255, 1)",
                    },
                  }}
                >
                  <CloseIcon sx={{ color: "black" }} fontSize="medium" />
                </IconButton>
              </Typography>
              <Grid
                padding={"0"}
                container
                spacing={2}
                columns={12}
                className="mb-2"
                sx={{ maxWidth: { md: 500 }, minWidth: { md: 500 } }}
              >
                <div className="row w-100">
                  <div className="col-md-12 col-12 col-lg-12">
                    <div className="AddListBox p-0">
                      <div
                        className="add-pr-url"
                        style={{ padding: "1rem 0rem 1rem 1.5rem" }}
                      >
                        <input
                          type="text"
                          autoComplete="true"
                          placeholder="BACKLINK LIST NAME"
                          onKeyUp={(e) => {
                            if (e.keyCode === 13) {
                              HandleCreateBackLIST();
                            }
                          }}
                          onChange={(e) => {
                            setListValue(e.target.value);
                            setinputEmptyErr(false);
                          }}
                        ></input>
                        {alertMsg && (
                          <h6
                            style={{
                              marginTop: "10px",
                              textAlign: "left",
                              fontSize: "12px",
                              color: "red",
                              width: "100%",
                            }}
                          >
                            {" "}
                            list name already exist
                          </h6>
                        )}

                        {inputEmptyErr && (
                          <h6
                            style={{
                              marginTop: "10px",
                              textAlign: "left",
                              fontSize: "12px",
                              color: "red",
                              width: "100%",
                            }}
                          >
                            {" "}
                            Please Type Something .
                          </h6>
                        )}

                        <div className="cmd mt-4  w-100">
                          <button
                            className="cm-btn-b"
                            onClick={() => {
                              handleClose();
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="cm-btn"
                            onClick={HandleCreateBackLIST}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              bgcolor: "rgba(255, 255, 255, 1)",
            }}
            className="popover-cont"
          >
            {/* {data?.length > 0 ? ( */}
            <Box sx={{ width: "100%" }}>
              <Typography
                component="h1"
                fontWeight={400}
                id="select-google-property"
                className="heading-large font-bold popover-list-header py-2 px-2"
              >
                Select List
                <IconButton
                  className="popover-close-icon"
                  onClick={handleClose}
                  sx={{
                    marginRight: "5px",
                    marginTop: "8px",
                    "&:hover": {
                      backgroundColor: "rgba(240, 242, 255, 1)",
                    },
                  }}
                >
                  <CloseIcon sx={{ color: "black" }} fontSize="mediun" />
                </IconButton>
              </Typography>
              <Grid
                container
                spacing={2}
                columns={12}
                className="mb-2"
                sx={{
                  maxWidth: { md: 500 },
                  minWidth: { md: 500 },
                  marginLeft: "-7px",
                  overflow: "hidden",
                }}
              >
                {ViewAllLists?.length > 0 ? (
                  <>
                    <ul className="listOfName w-100 mt-3 mx-3">
                      {DeleteLoading ? (
                        <div>
                          <div
                            className="d-flex justify-content-center align-items-center "
                            style={{ height: "35vh" }}
                          >
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden"></span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ViewAllLists?.map((listItem, index) => {
                          return (
                            <li
                              className="ListName d-flex justify-content-between"
                              id={index}
                              key={index}
                              onClick={() => {
                                AddColor(index);
                                handleGetListData(listItem);
                              }}
                            >
                              <p className="m-0 p-1">
                                {" "}
                                {listItem.back_list_name}
                              </p>
                              <Delete
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  HandleDeleteList(listItem.back_list_name)
                                }
                              />
                            </li>
                          );
                        })
                      )}
                    </ul>
                    <h4 className="fs-6 mt-2  text-center w-100">
                      <b>OR</b>
                    </h4>
                  </>
                ) : (
                  <></>
                )}
                <div
                  style={{
                    border:
                      !ViewAllLists.length > 0 ? "1px solid #a4a9af9c" : "none",
                    height: !ViewAllLists.length > 0 ? "11vh" : "auto",
                    width: !ViewAllLists.length > 0 ? "95%" : "auto",
                    display: !ViewAllLists.length > 0 ? "flex" : "auto",
                    justifyContent:
                      !ViewAllLists.length > 0 ? "center" : "auto",
                    alignItems: !ViewAllLists.length > 0 ? "center" : "auto",
                    margin:
                      !ViewAllLists.length > 0
                        ? "20px auto 10px auto"
                        : "8px auto 0px auto",
                  }}
                >
                  <button
                    className="AddListName mb-1"
                    onClick={HandleOpenAddList}
                  >
                    Create List
                  </button>
                </div>
                <div className="errorList m-0 w-100">
                  {ListChooseErr && (
                    <h6
                      style={{
                        marginTop: "10px",
                        marginLeft: "10px",
                        textAlign: "left",
                        fontSize: "12px",
                        color: "red",
                      }}
                    >
                      {" "}
                      Please Select One List.
                    </h6>
                  )}
                </div>
                <div className="cmd mt-2 ms-2 me-2 w-100 px-2">
                  <button
                    className="cm-btn-b"
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </button>
                  <button className="cm-btn" onClick={handleAddBackLink}>
                    Submit
                  </button>
                </div>
              </Grid>
            </Box>
          </Box>
        )}
      </PopOver>
    </div>
  );
};

export default BackLinks;
